<template>
    <Body :stage="stage">
        <div class="wrapper-list">
            <TierItemTheOne
                v-for="(item, idx) of tierList"
                :key="`tier-${idx}`"
                :item="item"
                @onClickTier="onClickTier"
            ></TierItemTheOne>
        </div>
    </Body>
</template>
<script>
//component
import TierItemTheOne from "../Tier/TierItem.vue";
import Body from "../Body/Body.vue";
export default {
    name: "Tier",
    props: {
        lbl: Object,
        lblCode: Number,
        theme: String,
        blobConfig: Object,
        objTier: Object,
        points: Number,
        stage: String,
    },
    emits: ["onClickTier"],
    components: {
        TierItemTheOne,
        Body,
    },
    data: function () {
        return {
            tierList: [],
            appName: "",
            currentPoints: 0,
        };
    },
    created: function () {
        if (this.objTier.point) {
            this.tierList = this.objTier.point;
        } else {
            this.tierList = [];
        }
    },
    mounted: function () {},
    methods: {
        onClickTier: function (data) {
            this.$emit("onClickTier", data);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/TheOne/style/base.scss";
@import "style/Tier.scss";
</style>

